export default "__VITE_PUBLIC_ASSET__af0baf30__"